import { Injectable } from '@angular/core';
import { CleanFillPolicyViewModel, PolicyClient } from '@services/cleanfill-api/cleanfill-api.generated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpPoliciesService {
  constructor(private policyClient: PolicyClient) {}

  getAllPolicies(): Observable<CleanFillPolicyViewModel[]> {
    return this.policyClient.getAllPolicies(undefined);
  }
}
